import { compose, hoistStatics, withHandlers, withState, lifecycle } from 'recompose';
import SelectImages from './SelectImages';
import ModelService from '../../services/image.service';

const defaultCriteria = {
  limit: 10,
  page: 0,
  order: 'desc',
  sortBy: 'id',
};

const updateData = async (props, criteria = defaultCriteria) => {
  const { data, count } = await ModelService.getData(criteria);
  await props.setData(data);
  await props.setCount(count);
};

const goToPage = props => async (nextPage) => {
  const page = nextPage > -1 ? nextPage : 0;
  const criteria = {
    ...defaultCriteria,
    page,
  };
  await props.setPage(page)
  await updateData(props, criteria);
//   await props.setCriteria(criteria);
};



const enhance = compose(
    withState('data', 'setData', []),
    withState('page', 'setPage', 0),
    withState('count', 'setCount', 0),
    lifecycle({
        async componentDidMount() {
            updateData(this.props)
        }
    }),
    withHandlers({
        goToPage,
        updateData: props => async (criteria = false) => updateData(props, criteria),
    }),
);

export default hoistStatics(enhance)(SelectImages);



// WEBPACK FOOTER //
// ./src/components/selectImages/index.js